module.exports = __webpack_public_path__ + "img/accounts.1222a028.svg";